import { c as _c } from "react/compiler-runtime";
import { UseUserSettingsInterface } from 'modules/profile/user-settings/types/user-settings-interface';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export const USER_SETTINGS_API = '/api/dashboard/settings/profile';
export function useUserSettings() {
  const $ = _c(4);
  const {
    user,
    isWorkspaceOwner
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    data: userSettings,
    mutate
  } = useControlledSwr(_temp, fetcher, undefined, !!user && isWorkspaceOwner);
  let t1;
  if ($[1] !== mutate || $[2] !== userSettings) {
    t1 = {
      userSettings,
      mutate
    };
    $[1] = mutate;
    $[2] = userSettings;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp() {
  return USER_SETTINGS_API;
}